export const SCHEMA_NAME = "Warrants";

export const FIELDS = {
  WARRANT_ID: "warrantID",
  JACKET_ID: "jacketID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  WARRANT_NUMBER: "warrantNumber",
  OTN: "otn",
  JURISDICTION: "jurisdiction",
  IN_GCIC: "inGCIC",
  CHARGE: "charge",
  CHARGE_COUNT: "chargeCount",
  DATE_ISSUED: "dateIssued",
  DATE_RECEIVED: "dateReceived",
  DATE_PROCESSED: "dateProcessed",
  ORI: "ori",
  AGENCY: "agency",
  DOCKET: "docket",
  WARRANT_TYPE: "warrantType",
  COMMENTS: "comments",
  PROSECUTOR: "prosecutor",
  PROSECUTOR_STREET_1: "prosecutorStreet1",
  PROSECUTOR_STREET_2: "prosecutorStreet2",
  PROSECUTOR_CITY: "prosecutorCity",
  PROSECUTOR_STATE: "prosecutorState",
  PROSECUTOR_ZIP: "prosecutorZip",
  PROSECUTOR_PHONE: "prosecutorPhone",
  ASSIGNED_TO: "assignedTo",
  BOND_TYPE: "bondType",
  BOND_DATE: "bondDate",
  BONDED_BY: "bondedBy",
  BOND_STREET_1: "bondStreet1",
  BOND_STREET_2: "bondStreet2",
  BOND_CITY: "bondCity",
  BOND_STATE: "bondState",
  BOND_ZIP: "bondZip",
  BOND_PHONE: "bondPhone",
  DISPOSITION: "disposition",
  OUTSTANDING_FLAG: "outstandingFlag",
  CASH_ACCOUNTING_TRANSACTION_ID: "cashAccountingTransactionID",
  JUDGE_NAME: "judgeName",
  PROSECUTOR_ADDRESS_ID: "prosecutorAddressID",
  USER: "user",
  NOTIFY_VICTIM: "notifyVictim",
  VICTIM_HAS_BEEN_NOTIFIED: "victimHasBeenNotified",
  CREATOR_STAFF_ID: "creatorStaffID",
  PROSECUTING_AGENCY: "prosecutingAgency",
  ORDINANCE: "ordinance",
  OFFENSE_CODE: "offenseCode",
  OFFENSE_DATE: "offenseDate",
  OFFENSE_TIME: "offenseTime",
  CHECK_BANK: "checkBank",
  CHECK_NUMBER: "checkNumber",
  CHECK_PAYABLE_TO: "checkPayableTo",
  CHECK_RETURN_REASON: "checkReturnReason",
  AFFIDAVIT: "affidavit",
  ARRESTING_OFFICER_STAFF_ID: "arrestingOfficerStaffID",
  ADDRESS_BOOK_ID: "addressBookID",
  ORIGINAL_CHARGE: "originalCharge",
  COURT_NUMBER: "courtNumber",
  WANT: "want",
  WANT_EXPIRATION_DATE: "wantExpirationDate",
  OFFENSE_CITY: "offenseCity",
  ORIGINAL_OFFENSE_CODE: "originalOffenseCode",
  PENDING: "pending",
  CHARGE_MODIFIER_ID: "chargeModifierID",
  SERVE_24_7: "serve247",
  BOND_AMOUNT: "bondAmount",
  CHECK_AMOUNT: "checkAmount",
  COURT_NAME_ID: "courtNameID",
  DATE_OF_EMANCIPATION: "dateOfEmancipation",
  JUVENILE_WARRANT: "juvenileWarrant",
  CRN_NO: "crnNo",
  STATUS_ID: "statusID",
  ADDITIONAL_CHARGE_INFO: "additionalChargeInfo",
  CHARGE_LEVEL_ID: "chargeLevelID",
  DATE_OF_VIOLATION: "dateOfViolation",
  SEALED: "sealed",
  USE_ALIAS: "useAlias",
  BIO_ALIAS_ID: "bioAliasID",
};
